var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.field)?_c('div',{staticClass:"field"},[_c('CodeEditor',{attrs:{"withButton":false,"readOnly":_vm.field.protected},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),_c('p',{staticClass:"errorMsg"},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }